// removed by extract-text-webpack-plugin
module.exports = {"overlay":"theme__overlay___2LA9x","active":"theme__active___1mb5R"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/overlay/theme.css
// module id = 1447
// module chunks = 0